import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function AssetSkeletonCard() {
	const { t } = useTranslation();
	return (
		<Card className="rounded-lg border shadow-sm hover:shadow-lg transition-all duration-200 hover:-translate-y-1 h-full flex flex-col overflow-hidden cursor-pointer py-0 w-100">
			<div className="relative h-55 w-full">
				<Skeleton className="h-full w-full rounded-lg rounded-b-none" />
			</div>

			<CardContent className="px-6 pb-6 flex flex-col">
				<div className="mb-4">
					<Skeleton className="h-5 w-3/4 mb-2" />
				</div>

				<div className="grid grid-cols-2 gap-4 mb-4">
					<div className="border rounded-lg p-4 h-full">
						<Skeleton className="h-5 w-3/4 mb-2" />
					</div>
					<div className="border rounded-lg p-4 h-full">
						<Skeleton className="h-5 w-3/4 mb-2" />
					</div>
				</div>

				<div className="mt-auto">
					<p className="text-xs mb-4 text-muted-foreground">{t('assets.card.activeDamages')}</p>
					<div className="flex space-x-3">
						<Skeleton className="h-5 w-3/4 mb-2" />
						<Skeleton className="h-5 w-3/4 mb-2" />
						<Skeleton className="h-5 w-3/4 mb-2" />
						<Skeleton className="h-5 w-3/4 mb-2" />
						<Skeleton className="h-5 w-3/4 mb-2" />
					</div>
				</div>
			</CardContent>
		</Card>
	);
}
